export const INSURANCE_OPTIONS = [
  { label: 'Medicare', value: 'Medicare' },
  { label: 'United Healthcare', value: 'United Healthcare' },
  { label: 'Aetna', value: 'Aetna' },
  { label: 'Humana Group', value: 'Humana Group' },
  { label: 'Blue Cross Blue Shield', value: 'Blue Cross Blue Shield' },
  {
    label: 'Connecticut General Life Insurance Company',
    value: 'Connecticut General Life Insurance Company',
  },
  { label: 'First Health Network', value: 'First Health Network' },
  {
    label: 'Guidewell Mutual Holding Group',
    value: 'Guidewell Mutual Holding Group',
  },
  {
    label: 'Elevance Health (Anthem BCBS)',
    value: 'Elevance Health (Anthem BCBS)',
  },
  { label: 'Centene Corporation', value: 'Centene Corporation' },
  {
    label: 'Blue Cross Blue Shield of North Carolina',
    value: 'Blue Cross Blue Shield of North Carolina',
  },
  { label: 'TRICARE', value: 'TRICARE' },
  { label: 'Cigna', value: 'Cigna' },
  {
    label: 'Oscar Insurance Corporation',
    value: 'Oscar Insurance Corporation',
  },
  { label: 'SCAN Health Plan', value: 'SCAN Health Plan' },
  { label: 'Medica Group', value: 'Medica Group' },
  { label: 'LA Care Health Plan', value: 'LA Care Health Plan' },
  {
    label: 'CareFirst BlueCross BlueShield',
    value: 'CareFirst BlueCross BlueShield',
  },
  {
    label: 'Anthem BlueCross BlueShield of Ohio',
    value: 'Anthem BlueCross BlueShield of Ohio',
  },
  {
    label: 'Blue Cross Complete Care of Michigan LLC',
    value: 'Blue Cross Complete Care of Michigan LLC',
  },
  { label: 'HealthFirst', value: 'HealthFirst' },
  {
    label: 'Blue Cross and Blue Shield Healthcare Plan of Georgia',
    value: 'Blue Cross and Blue Shield Healthcare Plan of Georgia',
  },
  {
    label: 'Anthem Blue Cross Blue Shield of Virginia',
    value: 'Anthem Blue Cross Blue Shield of Virginia',
  },
  { label: 'Medicaid', value: 'Medicaid' },
  {
    label: 'Blue Cross Blue Shield of Michigan',
    value: 'Blue Cross Blue Shield of Michigan',
  },
  { label: 'Molina Healthcare', value: 'Molina Healthcare' },
  {
    label: 'Blue Shield of California',
    value: 'Blue Shield of California',
  },
  { label: 'AARP', value: 'AARP' },
  {
    label: 'Blue Cross Blue Shield of Texas',
    value: 'Blue Cross Blue Shield of Texas',
  },
  { label: 'Kaiser Permanente', value: 'Kaiser Permanente' },
  {
    label: 'Horizon Blue Cross Blue Shield of New Jersey',
    value: 'Horizon Blue Cross Blue Shield of New Jersey',
  },
  {
    label: 'BlueCross BlueShield of Illinois',
    value: 'BlueCross BlueShield of Illinois',
  },
  {
    label: 'Fidelis Care (FKA New York State Catholic Health Plan Inc)',
    value: 'Fidelis Care (FKA New York State Catholic Health Plan Inc)',
  },
  { label: 'Meritain Health', value: 'Meritain Health' },
  { label: 'Premera Blue Cross Group', value: 'Premera Blue Cross Group' },
  {
    label: 'Empire BlueCross BlueShield (AKA Empire HealthChoice Assurance)',
    value: 'Empire BlueCross BlueShield (AKA Empire HealthChoice Assurance)',
  },
  {
    label:
      'Tufts Health Plan of Point32Health (FKA Healthcare Holdings - Tufts Health Plan)',
    value:
      'Tufts Health Plan of Point32Health (FKA Healthcare Holdings - Tufts Health Plan)',
  },
  {
    label: 'Priority Health Insurance Company Inc',
    value: 'Priority Health Insurance Company Inc',
  },
  {
    label: 'Jefferson Health Plans (FKA Health Partners Plans)',
    value: 'Jefferson Health Plans (FKA Health Partners Plans)',
  },
  { label: 'ElderPlan', value: 'ElderPlan' },
  {
    label: 'BlueCross BlueShield of Tennessee',
    value: 'BlueCross BlueShield of Tennessee',
  },
  { label: 'UPMC Health Plan Group', value: 'UPMC Health Plan Group' },
  {
    label: 'Sentara Health Plans (AK Optima Health Group)',
    value: 'Sentara Health Plans (AK Optima Health Group)',
  },
  {
    label: 'Blue Cross & Blue Shield of Rhode Island',
    value: 'Blue Cross & Blue Shield of Rhode Island',
  },
  { label: 'Medical Mutual of Ohio', value: 'Medical Mutual of Ohio' },
  {
    label: 'BlueCross BlueShield of Minnesota Group',
    value: 'BlueCross BlueShield of Minnesota Group',
  },
  { label: 'CareCentrix', value: 'CareCentrix' },
  {
    label: 'BlueCross BlueShield of Massachusetts Group',
    value: 'BlueCross BlueShield of Massachusetts Group',
  },
  { label: 'Empire', value: 'Empire' },
  { label: 'Mutual of Omaha', value: 'Mutual of Omaha' },
  {
    label: 'CareSource Management Group',
    value: 'CareSource Management Group',
  },
  {
    label:
      'Harvard Pilgrim Health Care of Point32Health (FKA Health Plan Holdings - Harvard Pilgrim Health Care Group)',
    value:
      'Harvard Pilgrim Health Care of Point32Health (FKA Health Plan Holdings - Harvard Pilgrim Health Care Group)',
  },
  { label: 'MVP Health Care', value: 'MVP Health Care' },
  { label: 'Highmark', value: 'Highmark' },
  {
    label: 'Keystone Health Plan East',
    value: 'Keystone Health Plan East',
  },
  {
    label: 'Blue Cross Blue Shield of Arizona',
    value: 'Blue Cross Blue Shield of Arizona',
  },
  {
    label: 'Blue Cross and Blue Shield of Vermont',
    value: 'Blue Cross and Blue Shield of Vermont',
  },
  {
    label:
      'Martins Point Health Care (AKA Martins Point Generations Advantage Plan)',
    value:
      'Martins Point Health Care (AKA Martins Point Generations Advantage Plan)',
  },
  {
    label: 'Anthem Blue Cross Blue Shield of Kentucky',
    value: 'Anthem Blue Cross Blue Shield of Kentucky',
  },
  {
    label:
      'Anthem Blue Cross Blue Shield of Connecticut (AKA Anthem Health Plans)',
    value:
      'Anthem Blue Cross Blue Shield of Connecticut (AKA Anthem Health Plans)',
  },
  { label: 'UCare Group', value: 'UCare Group' },
  { label: 'HealthChoice', value: 'HealthChoice' },
  {
    label:
      'BlueCross BlueShield of Louisiana (FKA Louisiana Health Service and Indemnity Company)',
    value:
      'BlueCross BlueShield of Louisiana (FKA Louisiana Health Service and Indemnity Company)',
  },
  { label: 'WebTPA', value: 'WebTPA' },
  {
    label: 'BlueCross BlueShield of South Carolina Group',
    value: 'BlueCross BlueShield of South Carolina Group',
  },
  { label: 'Noridian', value: 'Noridian' },
  {
    label: 'Consolidated Association of Railroad Employees HC',
    value: 'Consolidated Association of Railroad Employees HC',
  },
  {
    label: 'BlueCross BlueShield of Alabama',
    value: 'BlueCross BlueShield of Alabama',
  },
  {
    label: 'HIP an EmblemHealth Company',
    value: 'HIP an EmblemHealth Company',
  },
  { label: 'Workers Comp', value: 'Workers Comp' },
  {
    label: 'Meridian Health Plan of Michigan',
    value: 'Meridian Health Plan of Michigan',
  },
  { label: 'VA Health Care', value: 'VA Health Care' },
  { label: 'Innovacare Inc', value: 'Innovacare Inc' },
  {
    label: 'Geisinger Health Plan Group',
    value: 'Geisinger Health Plan Group',
  },
  { label: 'MultiPlan', value: 'MultiPlan' },
  {
    label: 'Anthem Blue Cross Blue Shield of Colorado',
    value: 'Anthem Blue Cross Blue Shield of Colorado',
  },
  {
    label: 'First Choice of the Midwest',
    value: 'First Choice of the Midwest',
  },
  {
    label:
      'Mass General Brigham Health Plan Select (FKA AllWays Health Partners Select)',
    value:
      'Mass General Brigham Health Plan Select (FKA AllWays Health Partners Select)',
  },
  { label: 'AvMed', value: 'AvMed' },
  { label: 'Trustmark Insurance', value: 'Trustmark Insurance' },
  {
    label: 'GHI an EmblemHealth Company',
    value: 'GHI an EmblemHealth Company',
  },
  {
    label: 'SummaCare Insurance Group',
    value: 'SummaCare Insurance Group',
  },
  {
    label: 'BlueCross BlueShield of Oklahoma',
    value: 'BlueCross BlueShield of Oklahoma',
  },
  { label: 'CHAMPVA', value: 'CHAMPVA' },
  {
    label: 'Anthem Blue Cross Blue Shield of Missouri',
    value: 'Anthem Blue Cross Blue Shield of Missouri',
  },
  { label: 'Auxiant', value: 'Auxiant' },
  { label: 'Network Health Group', value: 'Network Health Group' },
  { label: 'Optum', value: 'Optum' },
  { label: 'Curative', value: 'Curative' },
  { label: 'Viva Health', value: 'Viva Health' },
  {
    label: 'American Postal Workers Union Health Plan',
    value: 'American Postal Workers Union Health Plan',
  },
  {
    label: 'Allegiance Life & Health Insurance Company Inc',
    value: 'Allegiance Life & Health Insurance Company Inc',
  },
  { label: 'Health Share of Oregon', value: 'Health Share of Oregon' },
  {
    label: 'Clover Health (FKA CarePoint Health Plan)',
    value: 'Clover Health (FKA CarePoint Health Plan)',
  },
  {
    label: 'Inland Empire Health Plan (AKA IEHP)',
    value: 'Inland Empire Health Plan (AKA IEHP)',
  },
  {
    label: 'Presbyterian Healthcare Service Group',
    value: 'Presbyterian Healthcare Service Group',
  },
  {
    label: 'Anthem Blue Cross Blue Shield of Wisconsin',
    value: 'Anthem Blue Cross Blue Shield of Wisconsin',
  },
  {
    label: 'Regence BlueShield of Washington',
    value: 'Regence BlueShield of Washington',
  },
  { label: 'Humana', value: 'Humana' },
  {
    label: 'Partnership HealthPlan of California (AKA PHC)',
    value: 'Partnership HealthPlan of California (AKA PHC)',
  },
]
